/** Whole hryvnias — tariff prices, balances and history. */
export function formatAmount(amountMinor: number, currency: string) {
  return new Intl.NumberFormat('uk-UA', {
    style: 'currency',
    currency: currency || 'UAH',
    maximumFractionDigits: 0,
  }).format(amountMinor / 100)
}

/** Exact to the kopiyka — the checkout total is the number the customer actually pays. */
export function formatExactAmount(amountMinor: number, currency: string) {
  return new Intl.NumberFormat('uk-UA', {
    style: 'currency',
    currency: currency || 'UAH',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amountMinor / 100)
}

export function formatDate(value: string | null | undefined, emptyLabel = '') {
  if (!value) return emptyLabel
  return new Intl.DateTimeFormat('uk-UA', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(
    new Date(value),
  )
}

export function formatDateTime(value: string) {
  return new Intl.DateTimeFormat('uk-UA', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value))
}
